import { ACTION_ORDER_SELECTED } from './types';

const selectOrderForDetails = order => ({
  payload: { order },
  type: ACTION_ORDER_SELECTED,
});

export default selectOrderForDetails;
